/**
 * Created by karthikeyan.k on 04-12-2018.
 */
export class Limit {
  title: string;
  betlimitid: number;
  privacy: boolean;
  tableid: string;
  min: number;
  max: number;
}
